import React from 'react';
import styles from './Projects.module.css';
const ProjectsPage = () => {


    return (
        <>
        <h1>Projects</h1>
        </>
    )
}

export default ProjectsPage;

